/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import Dialog from "@mui/material/Dialog";
import axios from "axios";
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import MDButton from "components/MDButton";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import FormControl from "@mui/material/FormControl";
import MDBackdrop from "components/MDBackdrop";
import { useSnackbar } from "notistack";

import CloseIcon from '@mui/icons-material/Close';
import { useMaterialUIController } from "context";
import theme from "assets/theme";
import IconButton from '@mui/material/IconButton';
import { Image } from "antd";
import { Upload } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import InputAdornment from '@mui/material/InputAdornment';
import Typography from '@mui/material/Typography';
import FormLabel from '@mui/material/FormLabel';
import { allowVehicleText } from "utils/Constant";
import { allowOnlyAlphanumeric } from "utils/Constant";
import { getDecodedUserData } from "utils/Constant";



function PopAddVehicle(props) {

    const [controller] = useMaterialUIController();
    const { darkMode, sidenavColor } = controller;
    const [isBackdrop, setIsBackdrop] = useState(false);
    const { onClose } = props;
    const [data, setData] = useState([]);
    const [makeShow, setMakeShow] = useState([]);
    const [typeShow, setTypeShow] = useState([]);
    const [modelShow, setModelShow] = useState([]);
    const [variantShow, setVariantShow] = useState([]);
    const [status, setStatus] = useState("");
    const [batterycapacity, setBatteryCapacity] = useState("");
    const [connectorType, setConnectorType] = useState("");
    const [connectorTypeShow] = useState(["CCS2", "Type6", "Type2", "Type7"]);
    const [fileList, setFileList] = useState([]);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [registeration_number, setRegisterationNumber] = useState("");
    const [vin, setVin] = useState("");
    const [type, setType] = useState("");
    const [make, setMake] = useState("");
    const [model, setModel] = useState("");
    const [variant, setVariant] = useState("");
    const [isDialogOpen, setIsDialogOpen] = useState(props.isDialog);
    const [range, setRange] = useState("");
    const [errors, setErrors] = useState({});

    const VALIDATION_RULES = {
        registration: { min: 1, max: 12 },
        make: { min: 2, max: 30 },
        model: { min: 1, max: 30 },
        variant: { min: 1, max: 30 },
        vin: { min: 17, max: 17 },
        battery: { min: 1, max: 1000 },
        range: { min: 1, max: 2000 },
    };

    const IMAGE_TYPES = ["image/jpeg", "image/png"];

    const validateText = (value, min, max, regex, fieldName) => {
        if (!value) return `${fieldName} is required`;
        if (value.length < min || value.length > max)
            return `${fieldName} must be ${min}-${max} characters`;
        if (!regex.test(value))
            return `Invalid ${fieldName}`;
        return "";
    };

    const validateNumber = (value, min, max, fieldName) => {
        if (!value) return `${fieldName} is required`;
        if (value < min || value > max)
            return `${fieldName} must be between ${min} and ${max}`;
        return "";
    };

    const beforeUpload = (file) => {
        if (!IMAGE_TYPES.includes(file.type)) {
            enqueueSnackbar("Only JPG or PNG images are allowed", { variant: "error" });
            return Upload.LIST_IGNORE;
        }
        return true;
    };


    const navigate = useNavigate();

    const uploadButton = (
        <button
            style={{
                border: 0,
                background: 'none',
                color: 'grey'
            }}
            type="button"
        >
            <PlusOutlined />
            <div
                style={{
                    marginTop: 8,
                }}
            >
                Upload
            </div>
        </button>
    );
    useEffect(() => {
        setIsDialogOpen(props.isDialog);
    }, [props.isDialog]);

    const getBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    const { enqueueSnackbar } = useSnackbar();
    useEffect(() => {
        getMake();
    }, []);
    const handleUploadChange = ({ fileList: newFileList }) => setFileList(newFileList);
    const getMake = () => {
        axios({
            method: "get",
            url: process.env.REACT_APP_BASEURL + "vehicle/all",

            withCredentials: true,

        })
            .then((response) => {
                if (response.data.success === true) {

                    const data = response.data.data[0];
                    setData(response.data.data[0]);
                    const makes = Object.keys(data);
                    setTypeShow(makes);
                    setMakeShow([]);

                    setModelShow([]);
                    setVariantShow([]);
                } else {
                }
            })
            .catch((error) => {
            });
    };

    const createUser = (registeration_number, status, make, model, variant, batterycapacity, connectorType, range, fileList, vin) => {

        const bodyFormData = new FormData();





        bodyFormData.append("type", "4-Wheeler");
        bodyFormData.append("make", make);
        bodyFormData.append("model", model);
        bodyFormData.append("variant", variant);
        bodyFormData.append("claimed_range", range);
        bodyFormData.append("battery_capacity", batterycapacity);
        bodyFormData.append("connector_type", connectorType);
        bodyFormData.append("vehicle_reg", registeration_number);
        bodyFormData.append("vin", vin);
        bodyFormData.append('image', fileList?.[0]?.originFileObj);


        axios({
            method: "post",
            url: process.env.REACT_APP_BASEURL + "vehicle",
            data: bodyFormData,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            withCredentials: true,
        })
            .then((response) => {
                if (response?.data?.success === true) {
                    enqueueSnackbar(response?.data?.message, { variant: 'success' })
                    window.location.reload();

                } else {


                    enqueueSnackbar(response?.data?.message, { variant: 'error' })

                }
            })
            .catch((error) => {
                enqueueSnackbar(error?.response?.data?.message, { variant: 'error' })




            });
    };



    const handlePreview = async (file) => {
        setIsBackdrop(false);
        setIsDialogOpen(false);
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        setPreviewImage(file.url || file.preview);
        setPreviewOpen(true);
    };

    const isNegative = Number(batterycapacity) < 0;


    const handleSubmit = (e) => {
        e.preventDefault();

        const newErrors = {
            registeration_number: validateText(
                registeration_number,
                VALIDATION_RULES.registration.min,
                VALIDATION_RULES.registration.max,
                /^[A-Za-z0-9]+$/,
                "Registration Number"
            ),

            make: !allowVehicleText(make)
                ? "Only letters, numbers, spaces, and . , & ( ) ' + - / are allowed."
                : "",


            model: !allowVehicleText(model)
                ? "Only letters, numbers, spaces, and . , & ( ) ' + - / are allowed."
                : "",


            variant: !allowVehicleText(variant)
                ? "Only letters, numbers, spaces, and . , & ( ) ' + - / are allowed."
                : "",


            vin: validateText(
                vin,
                VALIDATION_RULES.vin.min,
                VALIDATION_RULES.vin.max,
                /^[A-Za-z0-9]+$/,
                "VIN"
            ),

            batterycapacity: validateNumber(
                batterycapacity,
                VALIDATION_RULES.battery.min,
                VALIDATION_RULES.battery.max,
                "Battery Capacity"
            ),

            range: validateNumber(
                range,
                VALIDATION_RULES.range.min,
                VALIDATION_RULES.range.max,
                "Range"
            ),

            connectorType: !connectorType ? "Connector Type is required" : "",
            image: fileList.length === 0 ? "Vehicle image is required" : "",
        };

        setErrors(newErrors);

        const hasErrors = Object.values(newErrors).some(Boolean);
        if (hasErrors) {
            enqueueSnackbar("Please fix validation errors", { variant: "error" });
            return;
        }

        createUser(
            registeration_number,
            status,
            make,
            model,
            variant,
            batterycapacity,
            connectorType,
            range,
            fileList,
            vin
        );
    };
    const handleClose = () => {
        onClose(false);
    };




    const reset = (event) => {
        event.preventDefault();
        setRegisterationNumber("");
        setStatus("");
        setType("");
        setMake("");
        setModel("");
        setVariant("");
        setBatteryCapacity("");
        setConnectorType("");
        setFileList([]);
        setRange("");
        setMakeShow([]);
        setModelShow([]);
        setVariantShow([]);
        setErrors({});

    }

    useEffect(() => {
        if (
            getDecodedUserData()?.login_status !== "true"
        ) {
            navigate("/sign-in");
        }
    }, []);
    const handlePreviewClose = () => {
        setPreviewImage('');
        setPreviewOpen(false);

        setIsDialogOpen(true);
    };

    return (
        <>
            {previewImage && (
                <Image
                    wrapperStyle={{
                        display: 'none',

                    }}
                    preview={{
                        visible: previewOpen,
                        onVisibleChange: (visible) => {
                            setPreviewOpen(visible);
                            if (!visible) handlePreviewClose();
                        },
                        afterOpenChange: (visible) => {
                            if (!visible) handlePreviewClose();
                        },


                    }}
                    src={previewImage}
                />
            )}
            <MDBackdrop isBackdrop={isBackdrop} />
            <Dialog open={isDialogOpen} onClose={handleClose} fullWidth={false}   // stop stretching
                PaperProps={{
                    sx: {
                        width: 1000,     // exact width (adjust if needed)
                        borderRadius: "12px",
                    },
                }}>
                <DialogTitle style={darkMode ? { backgroundColor: "#202940", color: "#ffffff", display: "flex", alignItems: "center", justifyContent: "space-between" } : { theme, display: "flex", alignItems: "center", justifyContent: "space-between" }}>

                    Vehicle information
                    <IconButton aria-label="delete" onClick={handleClose} style={darkMode ? { color: "#ffffff" } : theme}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent style={darkMode ? { backgroundColor: "#202940", color: "#ffffff" } : theme}>
                    <MDBox pt={0} pb={0} px={3}>
                        <MDBox pt={0}>
                        </MDBox>

                        <MDBox p={2} component="form" role="form">
                            <MDBox p={1}>
                                <MDInput
                                    type="text"
                                    label="Registeration number"
                                    value={registeration_number}
                                    name="registeration_number"
                                    margin="dense"
                                    fullWidth={true}
                                    onChange={(e) => setRegisterationNumber(e.target.value)}
                                    onBlur={(e) => {
                                        const value = e.target.value;

                                        setErrors((prev) => ({
                                            ...prev,
                                            registeration_number: allowOnlyAlphanumeric(value)
                                                ? ""
                                                : "Only letters and numbers are allowed",
                                        }));
                                    }}
                                    error={Boolean(errors.registeration_number)}
                                    helperText={errors.registeration_number}
                                    FormHelperTextProps={{
                                        sx: {
                                            color: "#d32f2f",
                                            fontSize: "12px",
                                            marginLeft: "4px",
                                        },
                                    }}
                                    InputProps={{
                                        inputProps: {
                                            maxLength: 12,
                                        },
                                    }}
                                />
                            </MDBox>
                            <MDBox p={1}>
                                <MDInput
                                    type="text"
                                    label="VIN"
                                    value={vin}
                                    name="vin"
                                    margin="dense"
                                    fullWidth={true}
                                    onChange={(e) => setVin(e.target.value)}
                                    onBlur={(e) => {
                                        const value = e.target.value;

                                        setErrors((prev) => ({
                                            ...prev,
                                            vin: allowOnlyAlphanumeric(value)
                                                ? ""
                                                : "Only letters and numbers are allowed",
                                        }));
                                    }}
                                    error={Boolean(errors.vin)}
                                    helperText={errors.vin}
                                    FormHelperTextProps={{
                                        sx: {
                                            color: "#d32f2f",
                                            fontSize: "12px",
                                            marginLeft: "4px",
                                        },
                                    }}
                                    InputProps={{
                                        inputProps: {
                                            maxLength: 17,
                                        },
                                    }}
                                />
                            </MDBox>

                            <MDBox p={1}>
                                <MDInput
                                    type="text"
                                    label="Make"
                                    value={make}
                                    name="make"
                                    margin="dense"
                                    fullWidth={true}
                                    onChange={(e) => setMake(e.target.value)}
                                    onBlur={(e) => {
                                        const value = e.target.value;

                                        setErrors((prev) => ({
                                            ...prev,
                                            make: allowVehicleText(value)
                                                ? ""
                                                : "Only letters, numbers, spaces, and . , & ( ) ' + - / are allowed.",
                                        }));
                                    }}
                                    error={Boolean(errors.make)}
                                    helperText={errors.make}
                                    FormHelperTextProps={{
                                        sx: {
                                            color: "#d32f2f",
                                            fontSize: "12px",
                                            marginLeft: "4px",
                                        },
                                    }}
                                    InputProps={{
                                        inputProps: {
                                            maxLength: 30,
                                        },
                                    }}

                                />
                            </MDBox>

                            <MDBox p={1}>
                                <MDInput
                                    type="text"
                                    label="Model"
                                    value={model}
                                    name="model"
                                    margin="dense"
                                    fullWidth={true}
                                    onChange={(e) => setModel(e.target.value)}
                                    onBlur={(e) => {
                                        const value = e.target.value;

                                        setErrors((prev) => ({
                                            ...prev,
                                            model: allowVehicleText(value)
                                                ? ""
                                                : "Only letters, numbers, spaces, and . , & ( ) ' + - / are allowed.",
                                        }));
                                    }}
                                    error={Boolean(errors.model)}
                                    helperText={errors.model}
                                    FormHelperTextProps={{
                                        sx: {
                                            color: "#d32f2f",
                                            fontSize: "12px",
                                            marginLeft: "4px",
                                        },
                                    }}
                                />
                            </MDBox>

                            <MDBox p={1}>
                                <MDInput
                                    type="text"
                                    label="Variant"
                                    value={variant}
                                    name="variant"
                                    margin="dense"
                                    fullWidth={true}
                                    onChange={(e) => setVariant(e.target.value)}
                                    onBlur={(e) => {
                                        const value = e.target.value;
                                        setErrors((prev) => ({
                                            ...prev,
                                            variant: allowVehicleText(value)
                                                ? ""
                                                : "Only letters, numbers, spaces, and . , & ( ) ' + - / are allowed.",
                                        }));
                                    }}
                                    error={Boolean(errors.variant)}
                                    helperText={errors.variant}
                                    FormHelperTextProps={{
                                        sx: {
                                            color: "#d32f2f",
                                            fontSize: "12px",
                                            marginLeft: "4px",
                                        },
                                    }}
                                />
                            </MDBox>
                            <MDBox p={1}>
                                <MDInput
                                    type="number"
                                    label="Battery Capacity"
                                    value={batterycapacity}
                                    name="batterycapacity"
                                    margin="dense"
                                    fullWidth
                                    error={isNegative}
                                    helperText={
                                        isNegative ? "Battery capacity should be non negative" : ""
                                    }
                                    inputProps={{ min: 0 }}
                                    onChange={(e) => setBatteryCapacity(e.target.value)}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        fontSize: "16px",
                                                        fontWeight: "bold",
                                                        color: darkMode ? "#fff" : "black",
                                                        mr: isNegative ? 2 : 0, 
                                                    }}
                                                >
                                                    kW
                                                </Typography>
                                            </InputAdornment>
                                        ),
                                    }}
                                    FormHelperTextProps={{
                                        sx: { marginLeft: 0 }, 
                                    }}
                                />
                            </MDBox>

                            <MDBox p={1}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-multiple-name-label">Connector Type</InputLabel>
                                    <Select
                                        sx={{
                                            height: 50,
                                        }}
                                        labelId="demo-multiple-name-label"
                                        id="demo-multiple-name"
                                        placeholder="Select Connector Type"
                                        value={connectorType}
                                        name="connectorType"
                                        onChange={(e) => setConnectorType(e.target.value)}





                                        input={<OutlinedInput label="connectorType" />}
                                    >
                                        {connectorTypeShow.map((name, index) => (
                                            <MenuItem
                                                key={index}
                                                value={name}

                                            >
                                                {name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </MDBox>

                            <MDBox p={1}>
                                <MDInput
                                    type="number"
                                    label="Range"
                                    value={range}
                                    name="range"


                                    margin="dense"
                                    fullWidth={true}
                                    onChange={(e) => setRange(e.target.value)}
                                    InputProps={{
                                        endAdornment: <InputAdornment position="end">
                                            <Typography variant="body2" style={{ fontSize: '16px', fontWeight: "bold", color: darkMode ? "#ffff" : "black" }}>KM</Typography>
                                        </InputAdornment>,
                                    }}
                                />
                            </MDBox>
                            <MDBox p={1}>
                                <FormLabel >Vehicle Image</FormLabel>
                            </MDBox>
                            <MDBox p={1}>
                                <Upload
                                    beforeUpload={beforeUpload}
                                    customRequest={({ onSuccess }) => setTimeout(() => onSuccess("ok"), 0)}
                                    listType="picture-card"
                                    fileList={fileList}
                                    onPreview={handlePreview}
                                    onChange={handleUploadChange}
                                >
                                    {fileList.length >= 1 ? null : uploadButton}
                                </Upload>
                                {errors.image && (
                                    <Typography color="error" fontSize="12px">
                                        {errors.image}
                                    </Typography>
                                )}



                            </MDBox>
                        </MDBox>
                    </MDBox>
                </DialogContent>
                <DialogActions style={darkMode ? { backgroundColor: "#202940", justifyContent: "space-evenly", color: "#ffffff" } : { theme, justifyContent: "space-evenly" }}>
                    {/* <Button onClick={handleSubmit} autoFocus>
                        Upload File
                    </Button> */}
                    <MDButton variant="gradient" color={sidenavColor} onClick={reset}>
                        Reset
                    </MDButton>
                    <MDButton variant="gradient" color={sidenavColor}
                        onClick={handleSubmit}
                    >
                        Submit
                    </MDButton>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default PopAddVehicle;
